import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { CSSTransition } from "react-transition-group";
import { useDrop } from "react-dnd";

import styles from "./phoneme.module.css";
import * as phonemeActions from "../../redux/actions/phoneme";
import { srcPath } from "../../util/Path";
import { State } from "../../redux/store";
import Ribbon from "./Ribbon";
import BasketItem from "./BasketItem";
import { dndItemTypes } from "../../react-dnd/DndConfig";

interface DragItem {
  type: string;
  word: string;
}

const BasketPage = () => {
  const dispatch = useDispatch();

  const { basketItems, basketReadyEnd } = useSelector(
    (state: State) => state.phoneme
  );
  const [itemLoaded, setItemLoaded] = useState(false);

  const dragItem = (item: DragItem) => {
    dispatch(phonemeActions.selectBasketItem(item.word));
  };

  const [{ isOver }, drop] = useDrop({
    accept: dndItemTypes.PHONEME_BASKET_ITEM,
    drop: dragItem,
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  });

  useEffect(() => {
    const timeout = setTimeout(() => setItemLoaded(true), 2000);
    return () => clearTimeout(timeout);
  }, [setItemLoaded]);

  return (
    <CSSTransition
      in={basketReadyEnd}
      timeout={500}
      classNames={{
        enter: styles.basketPageEndEnter,
        enterActive: styles.basketPageEndEnterActive,
        enterDone: styles.basketPageEndEnterDone,
      }}
    >
      <div className={styles.basketPage}>
        {basketItems.map((item, index) => (
          <BasketItem
            key={index}
            word={item}
            outIndex={index}
            itemLoaded={itemLoaded}
          />
        ))}
        <div className={styles.basketContainer}>
          <img
            className={styles.basket}
            src={srcPath("phoneme/basket.png")}
            alt=""
          />
          <div
            ref={drop}
            className={styles.basketDrop}
            style={
              {
                // backgroundColor: `rgba(256, 256, 256, ${isOver ? 0.1 : 0.2})`,
              }
            }
          ></div>
          <Ribbon style={{ top: "-70px", transform: "scale(0.8)" }} />
        </div>
      </div>
    </CSSTransition>
  );
};

export default BasketPage;
